import * as notify from './notification.service';

/**
 * This is a global error handler for those errors which are coming from backend
 * @param error
 * @param handlers
 */
export const handleGlobalErrors = (
  error: {
    response: { handled: boolean; status: any; data: { error: { message: string } } };
    message: string;
  },
  handlers: { authenticationErrorHandler: () => void },
) => {
  if (!error || !error.response) {
    notify.error('Something went wrong');
  }
  error.response.handled = true;
  switch (error.response.status) {
    case 401:
      notify.error(
        error.response.data && error.response.data.error
          ? error.response.data.error.message
          : 'Session expired. Please login again.',
      );
      if (typeof handlers.authenticationErrorHandler === 'function') {
        handlers.authenticationErrorHandler();
      }
      break;
    case 500:
      notify.error(
        error.response.data && error.response.data.error
          ? error.response.data.error.message
          : error.message,
      );
      break;
    case 404:
      notify.error(error.message);
      break;
    default:
      error.response.handled = false;
  }
  return error;
};

/**
 * This is a UBO error handler for those errors which are coming from backend
 * @param error
 */
export const handleUBOErrors = (error: any) => {
  let errorMessage: string;

  const errorData = error?.response?.data?.error;
  if (errorData && errorData.errorMessages && errorData.errorMessages.length) {
    // Use the message from errorMessages if it exists
    errorMessage = `${errorData.message}, ${errorData.errorMessages[0].message}`;
  } else if (errorData && errorData.message) {
    // Use the message from the error object if it exists
    errorMessage = errorData.message;
  } else if (error?.response?.data?.message) {
    // use this message if error message return only in response data
    errorMessage = error?.response?.data?.message;
  } else {
    // Fallback to a generic error message
    errorMessage = 'Error getting results';
  }

  notify.error(errorMessage);
};
